import { Component, OnInit } from "@angular/core";
import { MessageService } from "primeng/api";
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from "primeng/dynamicdialog";
import { SecurityToMap } from "src/api/models";
import { SecurityMappingService } from "src/api/services";
import { sanitizeForm } from "../../../../../core/utils/form-clean";
import {
  handlePasteWithoutLeadingSpaces,
  preventLeadingSpaceKey,
} from "src/core/utils/input-validation.utils";
type FormData = {
  cfiCode: string;
   asReportedSecurityType: string; 
};

// Only string keys of formData
type StringFormDataKeys = {
  [K in keyof FormData]: FormData[K] extends string ? K : never;
}[keyof FormData];
type PasteField = StringFormDataKeys | keyof MapSecurityDataComponent | "asReportedSecurityType";
@Component({
  selector: "app-map-security-data",
  // imports: [],
  templateUrl: "./map-security-data.component.html",
  styleUrl: "./map-security-data.component.css",
  standalone: false,
})
export class MapSecurityDataComponent implements OnInit {
  securities: any[] = [];
  selectedSecurities: any[] = [];
  selectedDialogRow: any = null;
  searchSecurityType: string = "";
  remap = false;
  first = 0;
  rows = 10;
  formData = {
    asReportedSecurityId: "",
    issuerId: undefined as number | undefined,
    asReportedSecurityType: "",
    issuerName: "",
    cfiCode: "",
    selectedSecurityType: null as { label: string; value: string } | null, // Change this to null
  };
  isLoading: boolean = false;
  searchSecurity: string = "";
  showDropdown = false;
  filteredSecurities: any[] = [];
  selectedSecurity: any = null;
  securityTypes = [
    { label: "American Depositary Shares", value: "EDS" },
    { label: "Capital Stock Class C", value: "ES" },
    { label: "Common Shares of Beneficial Interest", value: "ES" },
    { label: "Common Stock", value: "ES" },
    { label: "Common Stock Class A", value: "ES" },
    { label: "Common Stock Class A Non-voting", value: "ES" },
    { label: "Common Stock Class B", value: "ES" },
    { label: "Common Stock Class C", value: "ES" },
    { label: "Common Stock Series A", value: "ES" },
    { label: "Common Stock Series B", value: "ES" },
    { label: "Common Stock Series C", value: "ES" },
    { label: "Common Stock-Voting", value: "ES" },
    { label: "Common Units", value: "EU" },
    { label: "Preferred Stock", value: "EP" },
    { label: "Preferred Stock Class A", value: "EP" },
    { label: "Preferred Stock Class B", value: "EP" },
    { label: "Preferred Stock Class C", value: "EP" },
    { label: "Stock Options", value: "O" },
    { label: "Subordinate Common Stock", value: "ES" },
    { label: "Warrants", value: "RW" },
    { label: "Ordinary Shares", value: "ES" },
    { label: "Ordinary Shares Class A", value: "ES" },
  ];

  constructor(
    public config: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    private _securityMappingService: SecurityMappingService,
    public dialogService: DialogService,
    private _messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.selectedSecurities = this.config.data.securities;
    this.securities = this.config.data.securities;
    this.remap = this.config.data.remap;
  }

  onSubmit() {
    if (!this.securities?.length) {
      this._messageService.add({
        summary: "No securities available to map.",
        severity: "error",
      });
      return;
    }

    // Sanitize all securities in the array
    const sanitizedSecurities = this.securities.map((s) => sanitizeForm(s));

    // // Prepare theSecurity (taking the first one as representative)
    // const first = sanitizedSecurities[0];
    const reason = this.remap
      ? "Remapped to correct curated id successfully"
      : "Mapped to curated id successfully";
    const params: SecurityToMap = {
      asReportedSecurities: sanitizedSecurities.map((sec) => ({
        asReportedIssuerId: sec.asReportedIssuerId,
        asReportedIssuerName: sec.asReportedIssuerName,
        asReportedSecurityId: sec.asReportedSecurityId,
        asReportedSecurityType: sec.asReportedSecurityType,
        issuerId: sec.issuerId,
        issuerName: sec.issuerName,
        securityId: sec.securityId,
        totalCount: sec.totalCount,
      })),
      reason: reason,
      theSecurity: {
        reason: reason,
        securityType: this.formData.asReportedSecurityType?.trim(),
        cfiCode: this.formData.cfiCode?.trim(),
      },
    };

    this.isLoading = true;

    this._securityMappingService.doMapTheSecurity(params).subscribe({
      next: () => {},
      error: (err) => {
        this.isLoading = false;
        this._messageService.add({
          summary: err.error.message || "Mapping failed",
          severity: "error",
        });
      },
      complete: () => {
        this.isLoading = false;
        this.ref.close({ refresh: true });
      },
    });
  }

  onCancel() {
    this.ref.close();
  }
  onSecurityTypeChange() {
    if (!this.formData.selectedSecurityType) {
      this.formData.asReportedSecurityType = "";
      this.formData.cfiCode = "";
      return;
    }

    // Handle both string (custom input) and object (selected option) cases
    if (typeof this.formData.selectedSecurityType === "string") {
      // Custom text was entered
      this.formData.asReportedSecurityType = this.formData.selectedSecurityType;
      this.formData.cfiCode = "";
    } else {
      // Option was selected from dropdown
      this.formData.asReportedSecurityType =
        this.formData.selectedSecurityType.label;
      this.formData.cfiCode = this.formData.selectedSecurityType.value;
    }
  }
  preventSpaceKey(event: KeyboardEvent): void {
    preventLeadingSpaceKey(event);
  }
  // One universal paste handler for ALL fields
  onPaste(event: ClipboardEvent, field: PasteField): void {
    handlePasteWithoutLeadingSpaces(event, (newValue: string) => {
      if (field in this.formData) {
        // @ts-ignore
        this.formData[field as StringFormDataKeys] = newValue;
      } else {
        // @ts-ignore
        (this as any)[field] = newValue;
      }
    });
  }
}
